import { Outlet } from 'react-router-dom';

import { ContextMenuManager } from 'fluxo-ui';

import CommandPalette from '../components/common/CommandPalette';
import Header from '../components/common/Header';
import Sidebar from '../components/common/Sidebar';

const AuthLayout: React.FC = () => {
    return (
        <>
            <ContextMenuManager />
            <CommandPalette />
            <div className="min-h-screen flex bg-slate-50 dark:bg-slate-950">
                <Sidebar />
                <div className="flex-1 flex flex-col min-w-0">
                    <Header showSidebarToggle={true} />
                    <main className="flex-1 w-full overflow-x-hidden">
                        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default AuthLayout;
